// src/layouts/ChatLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";

export default function ChatLayout() {
  return (
    <div
      style={{
        height: "100dvh",
        overflow: "hidden",
        background: "#020617",
      }}
    >
      <Outlet />
    </div>
  );
}